import { Badge } from "@/components/ui/badge";
import { useCurrentRole, getRoleDisplayName, getRoleBadgeColor } from "@/lib/auth/roles";
import { useOrganization } from "@/contexts/OrganizationContext";
import { Shield } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

export function RoleBadge() {
  const { role, isSuperAdmin } = useCurrentRole();
  const { currentOrganization } = useOrganization();
  const { translate: t } = useTranslation();

  if (isSuperAdmin) {
    return (
      <div className="flex flex-col gap-1 min-w-0">
        <Badge className="bg-purple-500 hover:bg-purple-600 shrink-0 w-fit">
          <Shield className="h-3 w-3 mr-1" />
          {t("role_super_admin")}
        </Badge>
        {currentOrganization && (
          <span className="text-xs text-muted-foreground truncate" title={`${t("role_viewing")}: ${currentOrganization.name}`}>
            {t("role_viewing")}: {currentOrganization.name}
          </span>
        )}
      </div>
    );
  }

  if (!role) return null;

  return (
    <Badge className={`${getRoleBadgeColor(role)} hover:opacity-90`}>
      {getRoleDisplayName(role)}
    </Badge>
  );
}
